import { InputField, LabelField } from "components";
import { getCurrency } from "helper/numberFormat";

import React, { useEffect, useMemo } from "react";
import thousands from "thousands";
import { CheckFloatValue } from "../../../../utils/functions";

import { MyCheckbox } from "components";

export const NewPaymentMethod = ({

  formik,

  paymentMethodId,

  paymentType,

  ...props

}) => {

  const isOptionalObject = useMemo(() => {

    if (

      !Array.isArray(formik["values"]["allPaymentsMethods"]) ||

      formik["values"]["allPaymentsMethods"].length === 0

    )

      return;



    const currentComponent = formik["values"]["allPaymentsMethods"].find(

      (item) => {

        return item._id === paymentMethodId;

      }

    );

console.log(currentComponent,'testing')
    if (!currentComponent||!currentComponent._id) return;



    return {
      id:currentComponent?._id,
   coverConvenienceFee: currentComponent?.coverConvenienceFee ?? false,
      isOptional: currentComponent?.convenienceFeeInfo?.optional ?? false,

      message: currentComponent?.convenienceFeeInfo?.message,

      type: currentComponent?.type,

    };

  }, [formik["values"]]);

 useEffect(() => {
  if (!isOptionalObject?.isOptional) return;
  if (!key) return;

  if (formik.values[key] === undefined) {
    formik.setFieldValue(key, true);
  }
}, [key, isOptionalObject]);

  const key = `${isOptionalObject?.id}`;



  return (

    <>

      {isOptionalObject?.coverConvenienceFee &&isOptionalObject?.isOptional && ( // Todo:add optional true

        <div

          className="right-side px-0 py-2"

          style={{

             minWidth: "216px",
                   justifyContent: "flex-end",
    display: "flex",
    width: "89%",

          }}

        >

          <div className="d-flex align-items-center">

            <MyCheckbox

              name={key}

              checked={formik.values?.[key]}

              onClick={(e) => {

                formik.setFieldValue(key, e.target.checked);

              }}

            />

            <LabelField

              style={{ display: "flex", alignItems: "center", marginBottom: 0 }}

              title="Convenience Fee"

            />

          </div>

        </div>

      )}

    </>

  );
};
export const NewPaymentMethodHeader = ({
  formik,
  setPaymentMethodTitle,
  ...props
}) => {
  const currency = getCurrency();

  setPaymentMethodTitle(props.title + "_payment");
  const newPaymentMethod = props.title + "_payment";
  const { expanded, current, title } = props;
  const preventMinus = (e) => {
    const characterCode = e.key;
    if (characterCode === "Backspace") return;
    const characterNumber = Number(characterCode);
    if (characterNumber >= 0 && characterNumber <= 9) {
      if (e.currentTarget.value && e.currentTarget.value.length) {
        return;
      } else if (characterNumber === 0) {
        e.preventDefault();
      }
    } else {
      e.preventDefault();
    }
  };
  const handlefieldClick = (e) => {
    if (e.stopPropagation && expanded === true) {
      e.stopPropagation();
    }
  };
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
  const getCommaSeperatedValue = (num) => {
    return CheckFloatValue(parseFloat(num?.toString().replace(/,/g, "")))
      ?.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  return (
    <div
      className={
        expanded === false && current?.includes("title") === true
          ? "accordion-header"
          : expanded === false
            ? "accordion-payment-header"
            : expanded === true
              ? "accordion-header"
              : "accordion-header-payment"
      }
    >
      <LabelField title={props.title} />
      <div
        className={
          expanded === false && current.includes(title)
            ? "custom-expand dollor-icon col-sm-3 newpayment-nonexpanded-amount"
            : expanded === false &&
              current?.includes(title) === false &&
              formik.values?.[newPaymentMethod]
              ? "custom-expand dollor-icon col-sm-3 nonexpanded"
              : "col-sm-3"
        }
      >
        {expanded === false &&
          current?.includes(title) &&
          formik.values?.[newPaymentMethod] ? (
          <div className="cash-non-expanded">
            <span>{currency}</span>
            <span>
              {isNaN(formik.values?.[newPaymentMethod]) ? "0.00" : thousands((+formik.values?.[newPaymentMethod]).toFixed(2))}
              {/* {getCommaSeperatedValue(formik.values?.[newPaymentMethod])} */}
            </span>
          </div>
        ) : current?.includes(title) && expanded === true ? (
          <InputField
            {...{
              formik,
              title: "none",
              name: `val`,
              style: { background: "#ffff", border: "none" },
              value: formik.values?.[newPaymentMethod],
              placeholderIcon: (
                <span
                  className="align-self-center px-4"
                  style={{ color: "black" }}
                >
                  {currency}
                </span>
              ),
            }}
            handleChange={(event) => {
              formik.setFieldValue(
                newPaymentMethod,
                event.target.value.match(regex)[0]
              );
            }}
            onKeyDown={(e) => preventArrows(e)}
            paymentInput="paymentInput"
            handleFocus={(e) => handlefieldClick(e)}
          // onKeyDown={preventMinus}
          />
        ) : expanded === false &&
          current?.includes(title) === false &&
          formik.values?.[newPaymentMethod] ? (
          <div className="cash-non-expanded">
            <span>$</span>
            <span>
              {isNaN(formik.values?.[newPaymentMethod]) ? "0.00" : getCommaSeperatedValue(formik.values?.[newPaymentMethod])}
            </span>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
